import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import filterIcon from "../../assets/icons/Filter contacts.svg";
import {
  AiOutlineCloseCircle,
  AiOutlineRight,
  AiOutlineDown,
} from "react-icons/ai";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { MdLens, MdOutlineLens } from "react-icons/md";
import "../../assets/styles/local/taskFilter.css";
import TaskFilterCoWorker from "./TaskFilterCoWorker";
import ProjectsPopup from "./TaskFilterProject";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SelectedFilter = ({ filterItem, setFilterItem }) => {
  // first time page load filter start
  const getUserImage = () => {
    const imageUrl = localStorage.getItem("userimageurl");
    const initials = localStorage.getItem("initials");

    // Check if image URL exists
    if (imageUrl) {
      return (
        <img src={imageUrl} alt="" style={{ width: "30px", height: "30px" }} />
      );
    } else {
      return <span>{initials}</span>; // Display initials if no image URL
    }
  };

  const getUserImage2 = () => {
    const imageUrl = localStorage.getItem("userimageurl");
    const initials = localStorage.getItem("initials");

    // if we use dangerouslySetInnerHTML we have to these img and initial with literal
    if (imageUrl) {
      return `<img src="${imageUrl}" alt="Co-Worker" style="width: 25px; height: 25px; margin: 0px; object-fit: cover;" />`;
    } else {
      return `<span>${initials}</span>`; // Display initials if no image URL
    }
  };
  // first time page load filter end

  const removeItem = (itemToRemove) => {
    const val = {
      ...filterItem,
      [itemToRemove]: {},
    };
    setFilterItem(val);
  };

  const renderFilterButton = (label, value, itemKey, abbrevation) => (
    <div className="task-part-filter-btn-con" key={itemKey}>
      {/* <div
                className="task-part-filter-btn-label"
                dangerouslySetInnerHTML={{
                    __html:
                        label === "Co-Worker" && value !== "all"
                            ? `${label} <img src="${value}" />`
                            : `${label} <p>${value}</p>`,
                }}
            /> */}

      <div className="task-part-filter-btn-label">
        {value ? (
          <div
            className="d-flex align-items-center"
            dangerouslySetInnerHTML={{
              __html:
                label === "Co-Worker" && value !== "all"
                  ? `${label} <img src="${value}" />`
                  : `${label} <p>${value}</p>`,
            }}
          ></div>
        ) : (
          <div
            className="d-flex align-items-center"
            dangerouslySetInnerHTML={{
              __html:
                label === "Co-Worker" && value !== "all"
                  ? `${label} <p class="taskAbbr">${
                      abbrevation?.[0] || getUserImage2()
                    }</p>`
                  : `${label} <p>${value}</p>`,
            }}
          ></div>
        )}
      </div>

      <div
        onClick={() => removeItem(itemKey)}
        className="cursor-pointer"
        style={{ padding: "0 7px" }}
      >
        x
      </div>
    </div>
  );

  // Check if all project, coworker, and team filters are cleared, then set default filter to "All"
  const areFiltersCleared =
    !filterItem ||
    (!filterItem.projectId?.projectid &&
      !filterItem.coWorkerId?.userid &&
      !filterItem.teamId?.teamid);

  return (
    <>
      {areFiltersCleared && renderFilterButton("All", "", "all")}

      {filterItem?.projectId?.projectid &&
        renderFilterButton(
          "Project",
          filterItem.projectId.projectname,
          "projectId",
          filterItem.coWorkerId.firstname,
        )}

      {filterItem?.coWorkerId?.userid &&
        renderFilterButton(
          "Co-Worker",
          filterItem.coWorkerId.imageurl,
          "coWorkerId",
          filterItem.coWorkerId.firstname,
        )}

      {filterItem?.teamId?.teamid &&
        renderFilterButton(
          "Team",
          filterItem.teamId.teamname,
          "teamId",
          filterItem.coWorkerId.firstname,
        )}
    </>
  );
};

const FilterPopup = ({
  setFilterModal,
  filterItem,
  applyFun,
  fetchTransPlanBoadList,
}) => {
  const [isAllChecked, setIsAllChecked] = useState(true);
  const [isProjectsChecked, setIsProjectsChecked] = useState(false);
  const [isCoWorkerChecked, setCoWorkerChecked] = useState(false);
  const t = (key) => fetchTransPlanBoadList?.[key] || "";

  const [openProject, setOpenProject] = useState(false);
  const [openCoworker, setOpenCoworker] = useState(false);
  const [filters, setFilters] = useState({
    all: true,
    projectId: {},
    coWorkerId: {},
    teamId: {},
  });
  const handleItemClick = (item) => {
    if (item === "all") {
      setFilters({
        all: true,
        projectId: {},
        coWorkerId: {},
        teamId: {},
      });
    } else if (item.projectid) {
      setFilters(() => ({
        ...filters,
        all: false,
        projectId: item,
      }));
    } else if (item.userid) {
      setFilters(() => ({
        ...filters,
        all: false,
        coWorkerId: item,
        teamId: {},
      }));
    } else if (item.teamid) {
      setFilters(() => ({
        ...filters,
        all: false,
        teamId: item,
        coWorkerId: {},
      }));
    }

    setTimeout(() => {
      setOpenProject(false);
      setOpenCoworker(false);
    }, 400);
  };

  useEffect(() => {
    setFilters(filterItem);
    if (filterItem?.projectId?.projectid && filterItem?.coWorkerId?.userid) {
      // Both project and co-worker are selected
      // Prioritize project over co-worker
      setIsProjectsChecked(true);
      setCoWorkerChecked(true);
      setIsAllChecked(false);
    } else if (filterItem?.projectId?.projectid) {
      // Only project is selected
      setIsProjectsChecked(true);
      setCoWorkerChecked(false);
      setIsAllChecked(false);
    } else if (filterItem?.coWorkerId?.userid) {
      // Only co-worker is selected
      setIsProjectsChecked(false);
      setCoWorkerChecked(true);
      setIsAllChecked(false);
    } else {
      // Neither project nor co-worker is selected
      setIsProjectsChecked(false);
      setCoWorkerChecked(false);
      setIsAllChecked(true);
    }
  }, [filterItem]);

  const projectClickFuc = () => {
    setIsProjectsChecked(true);
    setIsAllChecked(false);
    setOpenProject(!openProject);
    setOpenCoworker(false);
  };
  const coWorkerClickFun = () => {
    setIsAllChecked(false);
    setCoWorkerChecked(true);
    setOpenProject(false);
    setOpenCoworker(!openCoworker);
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        position: "absolute",
        top: "0rem",
        left: "64%",
        zIndex: "99",
      }}
    >
      <div
        style={{
          borderRadius: "8px",
          background: "#FFFFFF ",
          boxShadow: "0px 6px 12px #2D2E1C1A",
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            padding: "10px 0",
          }}
        >
          <AiOutlineCloseCircle
            cursor={"pointer"}
            color="#BFBFBF"
            fontSize="1.2rem"
            onClick={() => {
              setFilterModal(false);
              setIsAllChecked(false);
              setIsProjectsChecked(false);
              setCoWorkerChecked(false);
              setOpenProject(false);
              setOpenCoworker(false);
            }}
          />
        </div>
        {/* all */}
        <div>
          <FormControlLabel
            value="all"
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isAllChecked}
                onClick={() => {
                  setIsAllChecked(!isAllChecked);
                  setIsProjectsChecked(false);
                  setCoWorkerChecked(false);
                  handleItemClick("all");
                  setOpenProject(false);
                  // setOpenCoworker(false);
                }}
              />
            }
            // label="All"
            label={t("all")}
            style={{
              fontSize: "12px !important",
              color: isAllChecked ? "#00246A" : "#333333",
              fontWeight: isAllChecked ? "800 !important" : "bold !important",
            }}
          />
        </div>
        {/* project */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            value="projects"
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isProjectsChecked}
                onClick={projectClickFuc}
              />
            }
            // label="Projects"
            label={t("project")}
            style={{
              fontSize: "12px !important",
              color: isProjectsChecked || openProject ? "#00246A" : "#333333",
              fontWeight: isProjectsChecked
                ? "800 !important"
                : "bold !important",
            }}
          />
          {!openProject ? (
            <AiOutlineRight
              id="basic-brand-button"
              aria-haspopup="true"
              aria-expanded={openProject ? "true" : undefined}
              onClick={projectClickFuc}
            />
          ) : (
            <AiOutlineDown />
          )}
          {openProject && (
            <ProjectsPopup
              open={openProject}
              handleClose={() => setOpenProject(false)}
              handleItemClick={handleItemClick}
              selectedProjectID={filterItem.projectId.projectid}
            />
          )}
        </div>
        {/* CoWorkerPopup */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            value="co-worker"
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isCoWorkerChecked}
                onClick={coWorkerClickFun}
              />
            }
            // label="Co-Worker"
            label={t("co-worker")}
            style={{
              fontSize: "12px !important",
              color: isCoWorkerChecked || openCoworker ? "#00246A" : "#333333",
              fontWeight: isCoWorkerChecked
                ? "800 !important"
                : "bold !important",
            }}
          />
          {!openCoworker ? (
            <AiOutlineRight
              id="basic-cat-button"
              aria-controls={openCoworker ? "basic-cat-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openCoworker ? "true" : undefined}
              onClick={coWorkerClickFun}
            />
          ) : (
            <AiOutlineDown />
          )}
        </div>
        {/* apply */}
        <div
          onClick={() => {
            setIsAllChecked(false);
            setIsProjectsChecked(false);
            setCoWorkerChecked(false);
            setFilterModal(false);
            setOpenCoworker(false);
            setOpenProject(false);
            applyFun(filters);
          }}
          style={{ padding: "10px 20px" }}
        >
          <div
            className="pro-part-add-itm-btn  d-flex"
            style={{ width: "150px" }}
          >
            <div className="pro-part-add-itm-btn-text">
              {/* Apply */}
              {t("apply")}
            </div>
          </div>
        </div>
      </div>
      {openCoworker && (
        <TaskFilterCoWorker
          modalOpen={openCoworker}
          // modalHideEv={() => setOpenCoworker(false)}
          modalHideEv={() => {
            setTimeout(() => {
              setOpenCoworker(!openCoworker);
            }, 400);
          }}
          handleItemClick={handleItemClick}
          // selectedCoWorkerID={filterItem.coWorkerId.userid}
          selectedCoWorkerID={filters.coWorkerId?.userid}
        />
      )}
    </div>
  );
};

const TaskFilterPopUp = ({ setFilterItem, filterItem }) => {
  const [filterModal, setFilterModal] = useState(false);

  const applyFun = (item) => {
    setFilterItem(item);
  };

  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  return (
    <div className="task-part-filter-con">
      <div className="pro-part-filter-label-con position-relative">
        <div className="filter-task ps-3 ps-lg-0">
          {/* Filters */}
          {t("filter")}
        </div>
        {filterModal && (
          <FilterPopup
            setFilterModal={setFilterModal}
            filterItem={filterItem}
            applyFun={applyFun}
            setFetchTransPlanBoadList={setFetchTransPlanBoadList}
            fetchTransPlanBoadList={fetchTransPlanBoadList}
          />
        )}
        <Image
          src={filterIcon}
          className="pro-part-add-itm-btn-icn"
          id="basic-button"
          aria-controls={filterModal ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={filterModal ? "true" : undefined}
          onClick={() => setFilterModal(true)}
        />
      </div>

      <SelectedFilter filterItem={filterItem} setFilterItem={setFilterItem} />
    </div>
  );
};

export default TaskFilterPopUp;
